import {
  House,
  Globe,
  Newspaper,
  TrendingUp,
  WalletCards,
  CircleDollarSign,
  Settings,
  Gem,
  ShieldUser,
} from "lucide-react";
import { SuperaltsLogo } from "@/components/marketplace/superalts-logo";
import { NavItem, Team, User } from "../types/sidebar";

export const getNavigationConfig = (
  location: string,
  isSettingsPage: boolean,
  isPortfoliosSection: boolean,
  isIndexPage: boolean,
  isBuildPortfolioPage: boolean,
  handleBuildPortfolioClick: (e: React.MouseEvent) => Promise<void>,
  userRole?: string
) => {
  const teams: Team[] = [
    {
      name: "Unis Lumen",
      logo: SuperaltsLogo,
      plan: "Marketplace",
    }
  ];

  const user: User = {
    name: "shadcn",
    email: "m@example.com",
    avatar: "",
  };

  const navItems: NavItem[] = [
    {
      title: "Dashboard",
      url: "/",
      icon: House,
      isActive: location === "/" || location === "/portfolios",
    },
    {
      title: "Discover",
      url: "/explore",
      icon: Globe,
      isActive: location === "/explore",
    },
    {
      title: "News",
      url: "#",
      icon: Newspaper,
    },
    {
      title: "Top Performers",
      url: "#",
      icon: TrendingUp,
    },
    {
      title: "Portfolios",
      url: "/portfolios",
      icon: WalletCards,
      isActive: location.startsWith("/portfolios") || location.startsWith("/portfolio/tools"),
      defaultOpen: true,
      items: [
        {
          title: "Build Portfolio",
          url: "/build-portfolio",
          isActive: isBuildPortfolioPage,
          onClick: handleBuildPortfolioClick,
        },
        {
          title: "Watchlist",
          url: "#",
        },
        {
          title: "WealthKit Tools",
          url: "/portfolio/tools",
          isActive: location === "/portfolio/tools",
        },
      ],
    },
    {
      title: "Accounts",
      url: "/investments",
      icon: CircleDollarSign,
      isActive: location.startsWith("/investments"),
      defaultOpen: true,
      items: [
        {
          title: "Connect",
          url: "/investments/connect",
          isActive: location === "/investments/connect",
        },
      ],
    },
    {
      title: "Assets",
      url: "/assets",
      icon: Gem,
      isActive: location.startsWith("/assets"),
    },
    {
      title: "Settings",
      url: "/settings",
      icon: Settings,
      isActive: location.startsWith("/settings"),
    },
    ...(userRole === 'sys_admin' ? [{
      title: "Admin",
      url: "/admin",
      icon: ShieldUser,
      isActive: location.startsWith("/admin"),
    }] : []),
  ];

  return { teams, user, navItems };
};
